import React, { useRef, useEffect, useState, useContext, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import api from '../api/api';
import { AuthContext } from '../contexts/AuthContext';
import { FilterContext } from '../contexts/FilterContext';
import { Dropdown } from 'primereact/dropdown';
import { DialogPrintRomaneios } from './DialogPrintRomaneios';
import { BrCalendar } from './BrCalendar';
import { DialogPrintRomaneiosEtiquetas } from './DialogPrintRomaneiosEtiquetas';
import { PermissaoLoader } from './PermissaoLoader';
import { permissions_check } from '../utils/rotas_permissao';

export const TabelaRomaneio = () => {
    const toast = useRef(null);
    const [romaneios, setRomaneios] = useState([]);
    const [produtor, setProdutor] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null)
    const [dt, setDt] = useState(null);
    const history = useHistory();
    const { user } = useContext(AuthContext);
    const [sortableCampo, setSortableCampo] = useState('id');
    const [sortable, setSortable] = useState('DESC');
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [showPrintRomaneios, setShowPrintRomaneios] = useState(false);
    const [showPrintRomaneiosEtiquetas, setShowPrintRomaneiosEtiquetas] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [romaneiosPrint, setRomaneiosPrint] = useState([]);
    const { filter, setFilter } = useContext(FilterContext);
    const filterStatus = renderFilterStatus();
    const [selectedDataEmissao, setSelectedDataEmissao] = useState(null);

    useEffect(() => {

    }, [romaneiosPrint])

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Romaneios</h2>
            </div>
            <div className="p-my-0 p-grid p-dir-rev p-col">
            <div className="p-m-2">
            <PermissaoLoader rota="romaneio" acao="criar" onClick={() => history.push('/romaneiocreate')}  />
                </div>
                <div className="p-m-2">
                    <Button
                        label="Limpar Filtros"
                        className="p-mb-2 p-button-primary"
                        iconPos="left"
                        type="button"
                        onClick={() => handleLimparClick()}
                    />
                </div>
            </div>
        </div>

    );

    const handleLimparClick = () => {
        setFilter({
            first: 0,
            rows: 20,
            sortField: null,
            sortOrder: null,
            filters: {
                'produtor': { value: null, matchMode: 'equals' },
                'id': { value: null, matchMode: 'equals' },
                'divida': { value: null, matchMode: 'equals' },
                'produtoNome': { value: null, matchMode: 'contains' },
                'dataEmissao': { value: null, matchMode: 'equals' },
            },

        });
        setSelectedStatus(null);
        setSelectedDataEmissao(null);
    }

    const getRomaneios = useCallback(async (event) => {
        setIsLoading(true)
        setRomaneios([])



        if (event !== undefined) {
            setTimeout(() => {
                const startIndex = event.first;

                setFirst(startIndex);
                // setPedras(dataSource.slice(startIndex, endIndex));
            }, 250);
        }
        try {

            console.log("Chamou getRomaneios --------------")

            console.log(filter.filters)

            if (filter.filters === undefined) {

                console.log("Filtro Indefinido --------------")

                if (event === undefined) {
                    const response = await api.get(`romaneio?sort=${sortableCampo},${sortable}`);

                    response.data.content.forEach(romaneio => {
                        setRomaneios(romaneios => [...romaneios, romaneio])
                    })
                } else {
                    const response = await api.get(`romaneio?page=${event.page}&sort=${sortableCampo},${sortable}`);

                    response.data.content.forEach(romaneio => {
                        setRomaneios(romaneios => [...romaneios, romaneio])
                    })

                }

                const respElements = await api.get(`romaneio?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);

            } else {

                console.log("Caiu na pesquisa ------------")

                const pesquisa = {
                    "produtor": filter.filters['produtor'] !== undefined ? filter.filters['produtor'].value : null,
                    "divida": filter.filters['divida'] !== undefined ? filter.filters['divida'].value : null,
                    "id": filter.filters['id'] !== undefined ? filter.filters['id'].value : null,
                    "produtoNome": filter.filters['produtoNome'] !== undefined ? filter.filters['produtoNome'].value : null,
                    "dataEmissao": filter.filters['dataEmissao'] !== undefined && filter.filters['dataEmissao'].value ? filter.filters['dataEmissao'].value : null,  
                }

                console.log(filter.filters)
                console.log("pesquisa: " + pesquisa.id);
                console.log(event);

                if (event === undefined) {
                    const respElements = await api.post(`romaneio/searchRomaneio/${sortable}/${sortableCampo}`, pesquisa);
                    console.log(respElements.data);
                    respElements.data.content.forEach(romaneio => {
                        setRomaneios(romaneios => [...romaneios, romaneio])
                    })
                    setTotalRecords(respElements.data.totalElements);
                } else {
                    const respElements = await api.post(`romaneio/searchRomaneio/${sortable}/${sortableCampo}?page=${event.page}`, pesquisa);
                    respElements.data.content.forEach(romaneio => {
                        setRomaneios(romaneios => [...romaneios, romaneio])
                    })
                    setTotalRecords(respElements.data.totalElements);
                }

            }

        }
        catch (error) {
            console.log("Caiu no erro ------------")

            if (filter !== undefined) {
                if (event === undefined) {
                    const response = await api.get(`romaneio?sort=id,${sortable}`);
                    response.data.content.forEach(romaneio => {
                        setRomaneios(romaneios => [...romaneios, romaneio])
                    })
                } else {
                    const response = await api.get(`romaneio?page=${event.page}&sort=id,${sortable}`);
                    response.data.content.forEach(romaneio => {
                        setRomaneios(romaneios => [...romaneios, romaneio])
                    })

                }

                const respElements = await api.get(`romaneio?sort=id,${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter romaneios', detail: error.toString() });
            }
        }


        setIsLoading(false)
    }, [filter, sortable, sortableCampo]);

    useEffect(() => {
        const fetchRomaneios = async () => {
            try {
                await getRomaneios();
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchRomaneios();
    }, [getRomaneios])

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-print" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handlePrintClick(rowData)} />
                <Button icon="pi pi-print" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handlePrintAllByDivida(rowData)} />
                <PermissaoLoader rota="romaneio" acao="editar" onClick={() => handleEditClick(rowData)} />
                <PermissaoLoader rota="romaneio" acao="deletar" loading={isDeleting} onClick={() => handleDeleteClick(rowData)} />
                <Button icon="pi pi-tag" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handlePrintClick(rowData, 'E')} />
                <Button icon="pi pi-tag" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handlePrintAllByDivida(rowData, 'E')} />

            </div>
        );
    }

    const codigoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const nomeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome do Produtor</span>
                    <span className="table-data">{rowData.pessoa.nome}</span>
                </p>
            </React.Fragment>
        );
    }

    const dataEmissaoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Data Emissão</span>
                    <span className="table-data">{new Date(rowData.dataEmissao).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</span>
                </p>
            </React.Fragment>
        );
    }

    const dividaBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Divida</span>
                    <span className="table-data">{rowData.divida}</span>
                </p>
            </React.Fragment>
        );
    }

    const itensBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Itens sem Qtde</span>
                <span className="p-button-rounded"
                    style={{
                        color:
                            rowData.tipoQuantidade === "SIM" ?
                                'red'
                                : rowData.tipoQuantidade === "PARCIAL" ?
                                    '#2196F3'
                                    : rowData.tipoQuantidade === "NÃO" ?
                                        'green'
                                        : 'black'
                    }}>
                    {rowData.tipoQuantidade}
                </span>
            </React.Fragment>
        );
    }


    const handleEditClick = (data) => {

        history.push(`/romaneio/edit/${data.id}`);

    }


    const handleDeleteClick = (data) => {

        data['userEmail'] = user.email

        confirmDialog({
            message: `Você tem certeza que quer remover ${data.divida}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {

                    await api.delete(`romaneio/${data.id}`);
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Romaneio ${data.id} removido(a) com sucesso` });
                    getRomaneios()
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover o romaneio', detail: "Error 500" });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }

    const handlePrintClick = (data, opcao = 'R') => {
        // console.log(filter);
        // console.log(data)
        api.get(`/romaneio/${data.id}`).then((response) => {

            setRomaneiosPrint([response.data]);
        })

        setTimeout(() => {
            if (opcao === "R") {
                setShowPrintRomaneios(true);
            } else {
                setShowPrintRomaneiosEtiquetas(true);
            }

        }, 1000)
    }

    const handlePrintAllByDivida = (data, opcao = 'R') => {

        // console.log(data)

        api.get(`/romaneio/dividas/${data.divida}`).then((response) => {
            console.log(response.data);
            setRomaneiosPrint(response.data);

        })

        setTimeout(() => {
            if (opcao === "R") {
                setShowPrintRomaneios(true);
            } else {
                setShowPrintRomaneiosEtiquetas(true);
            }

        }, 2000)

    }

    const mapearProdutor = useCallback(async () => {
        const response = await api.get(`pessoa/tipo/1`);
        setProdutor(response.data.map(produtor => {
            var prod = { label: '', value: '' };
            prod.label = produtor.nome
            prod.value = produtor.id

            return prod
        }))
        filter.filters !== undefined && (filter.filters.produtor !== undefined && filter.filters.produtor.value != null) ? setSelectedStatus(filter.filters.produtor.value) : setSelectedStatus(null)

    }, [filter]);

    useEffect(() => {

        async function romaneio() {
            await mapearProdutor();
        };
        romaneio();
    }, [mapearProdutor])

    const onStatusSearchChange = (event) => {
        if (event.value !== null) {
            dt.filter(event.value, 'produtor', 'equals');
            setSelectedStatus(event.value);
        }
        else
            dt.filter(null, 'produtor', 'equals');
    }

    const statusItemTemplate = (option) => {
        return <span className={`customer-badge status-${option}`}>{option}</span>;
    }

    function renderFilterStatus() {
        // console.log(produtor)
        return (
            <Dropdown
                value={selectedStatus}
                options={produtor}
                onChange={(e) => onStatusSearchChange(e)}
                placeholder="Selecione um produtor"
                className="p-column-filter"
                filter
                showClear={true} />
        );
    }

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if (sortable === 'ASC') {
            setSortable('DESC')
        } else if (sortable === 'DESC') {
            setSortable('ASC')
        }
    }

    const onFilter = (event) => {
        console.log(event);
        event['first'] = 0;
        // setLazyParams(event);
        setFilter(event);
    }

    // const onFilter = (event) => {

    //     event['first'] = 0;
    //     // Atualizando o filtro com os novos valores.
    //     setFilter(prevFilter => ({
    //         ...prevFilter,
    //         filters: {
    //             ...prevFilter.filters,
    //             // Adiciona qualquer outro filtro aqui, se necessário.
    //             [event.field]: event.filters[event.field]
    //         }
    //     }));
    // };


    const onDataEmissaoSearchChange = (event) => {
        if (event.value !== null) {
            let data = new Date(event.value.getTime() - (event.value.getTimezoneOffset() * 60000)).toISOString();
            dt.filter(data, 'dataEmissao', 'equals');
            setSelectedDataEmissao(event.value);
        }
        else
            dt.filter(null, 'dataEmissao', 'equals');
    }

    const onDataEmissaoInputChange = (event) => {
        if (event.target.value !== null) {
            let data = new Date(event.target.value.split('/').reverse().join('/'));
            let dataISO = new Date(data.getTime() - (data.getTimezoneOffset() * 60000)).toISOString();
            dt.filter(dataISO, 'dataEmissao', 'equals');
            setSelectedDataEmissao(new Date(event.target.value.split('/').reverse().join('/')));
        }
        else
            dt.filter(null, 'dataEmissao', 'equals');
    }

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

                <Toast ref={toast} position="bottom-right" />

                <Toast ref={confirmationToast} position="bottom-center" />

                <div className="card p-col-12 datatable-responsive-demo">

                    <div className="p-fluid">

                        <DataTable
                            totalRecords={totalRecords}
                            lazy="true"
                            onPage={getRomaneios}
                            first={first}
                            ref={(element) => setDt(element)}
                            filterDisplay="row"
                            header={header}
                            value={romaneios}
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhum romaneio encontrado"
                            loading={isLoading}
                            dataKey="id"
                            paginator
                            rows={20}
                            currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} romaneios`}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            // rowsPerPageOptions={[10, 20, 30]}
                            // sortField="nome" sortOrder={1}
                            // removableSort
                            onSort={onSort}
                            onFilter={onFilter}
                            filters={filter.filters}
                        >

                            <Column style={{ width: '12%' }}
                                field="id"
                                header="Código"
                                sortable={sortable}
                                body={codigoBodyTemplate}
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder={filter.filters !== undefined && (filter.filters.id !== undefined && filter.filters.id.value != null) ? filter.filters.id.value : "Pesquisar pelo Código"}

                            />

                            <Column
                                field="pessoa.nome"
                                header="Nome do Produtor"
                                sortable
                                body={nomeBodyTemplate}
                                filter
                                filterMatchMode="equals"
                                filterElement={filterStatus}

                            />


                            <Column
                                field="dataEmissao"
                                header="Data Emissão"
                                sortable
                                body={dataEmissaoBodyTemplate}
                                filter
                                filterElement={
                                    <BrCalendar
                                        key={selectedDataEmissao}
                                        id="dataEmissao"
                                        name="dataEmissao"
                                        value={selectedDataEmissao}
                                        onSelect={(e) => onDataEmissaoSearchChange(e)}
                                        onInput={(e) => onDataEmissaoInputChange(e)}
                                        yearRange={`2000:${new Date().getFullYear() + 2}`}
                                        placeholder="Selecione uma data"
                                        onClearButtonClick={() => handleLimparClick()}
                                    />
                                }
                            />

                            <Column
                                field="divida"
                                header="Divida"
                                sortable
                                body={dividaBodyTemplate}
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder={filter.filters !== undefined && (filter.filters.divida !== undefined && filter.filters.divida.value != null) ? filter.filters.divida.value : "Pesquisar pela Dívida"}

                            />

                            <Column
                                field="temQuantidadeZeroOuNull"
                                header="Quantidade zerado?"
                                body={itensBodyTemplate}

                            />

                            <Column
                                header="Ações"
                                field="produtoNome"
                                body={actionBodyTemplate}
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder={filter.filters !== undefined && (filter.filters.produtoNome !== undefined && filter.filters.produtoNome.value != null) ? filter.filters.produtoNome.value : "Pesquisar pelo Produto"}

                            />

                        </DataTable>

                        <DialogPrintRomaneios
                            visible={showPrintRomaneios}
                            setVisible={setShowPrintRomaneios}
                            setRomaneios={setRomaneiosPrint}
                            romaneios={romaneiosPrint}
                        />

                        <DialogPrintRomaneiosEtiquetas
                            visible={showPrintRomaneiosEtiquetas}
                            setVisible={setShowPrintRomaneiosEtiquetas}
                            setRomaneios={setRomaneiosPrint}
                            romaneios={romaneiosPrint}
                        />

                    </div>
                </div>
            </div>

        </>
    );
}
